export default __webpack_public_path__ + "static/media/gift.49dd5e43.svg";